import React from 'react';
const reviewsWithImage = [{
  image: 'https://cdn.shopify.com/s/files/1/1019/9361/1596/files/15d9e36d-5bb0-4fe3-b30b-8fef237b7c46.webp?v=1772971629',
  name: 'Florencia G.',
  text: 'Me encantó lo claro que está todo explicado paso a paso. En una semana noté menos hinchazón y mucha más energía.',
  tags: ['Digestión', 'Energía']
}, {
  image: 'https://cdn.shopify.com/s/files/1/1019/9361/1596/files/0de30204-307e-4336-a8eb-373d3ae909b0.webp?v=1772971628',
  name: 'Cintia A.',
  text: 'Recetas fáciles y deliciosas. Me siento más saciada y sin esa pesadez después de comer.',
  tags: ['Saciedad', 'Energía estable']
}, {
  image: 'https://cdn.shopify.com/s/files/1/1019/9361/1596/files/db828bbb-d9ee-4019-bf15-36c98e4a561d.webp?v=1772971627',
  name: 'Gabriela M.',
  text: 'Todo está muy bien organizado. Desde que sigo la guía me noto menos inflamada y con más vitalidad durante el día.',
  tags: ['Menos hinchazón', 'Vitalidad']
}];
const reviewsText = [{
  name: 'Carla M.',
  text: 'No imaginaba que pequeños cambios marcaran tanta diferencia. He notado mejoras en el descanso y en mi energía diaria.'
}, {
  name: 'Rocío C.',
  text: 'Pensé que sería complicado, pero es muy práctico. Me ha ayudado a sentirme más ligera y con menos inflamación.'
}, {
  name: 'Lorena P.',
  text: 'En pocas semanas he notado más estabilidad y mejor digestión. Muy recomendable.'
}];
export function ReviewsSection() {
  return;
}